// src/pages/Admin/YearsEdit.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import EditConfirmationModal from '../../components/common/EditConfirmationModal';
import TitleWithBack from '../../components/common/TitleWithBack';

function YearsEdit() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [tooltip, setTooltip] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [showConfirm, setShowConfirm] = useState(false);

  useEffect(() => {
    axios.get(`/api/years-of-study/${id}`)
      .then(response => {
        setName(response.data.name || '');
        setLoading(false);
      })
      .catch(() => {
        setError('Error fetching year data.');
        setLoading(false);
      });
  }, [id]);

  const updateYear = async () => {
    try {
      await axios.put(`/api/years-of-study/${id}`, { name });
      setTooltip('Year updated successfully!');
      setTimeout(() => navigate('/admin/years-of-study'), 2000);
    } catch (err) {
      setTooltip('Error updating year.');
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setShowConfirm(true);
  };

  if (loading) return <p>Loading year data...</p>;
  if (error) return <div className="alert alert-danger">{error}</div>;

  return (
    <div className="container mt-2">
      <TitleWithBack title="Edit Year of Study" />
      <div className="card shadow-sm">
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="form-label">Year of Study</label>
              <input 
                type="text"
                className="form-control"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </div>
            <button type="submit" className="btn btn-primary">Update Year</button>
          </form>
          {tooltip && (
            <div className={`mt-3 alert ${tooltip.startsWith('Error') ? 'alert-danger' : 'alert-success'}`}>
              {tooltip}
            </div>
          )}
        </div>
      </div>
      {showConfirm && (
        <EditConfirmationModal 
          title="Confirm Update"
          message="Are you sure you want to update this year?"
          onConfirm={() => { setShowConfirm(false); updateYear(); }}
          onCancel={() => setShowConfirm(false)}
        />
      )}
    </div>
  );
}

export default YearsEdit;
